module.exports = __webpack_public_path__ + "images/emoji/hand.d9d2a7cf22f3f6692655.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/hand.png
// module id = eZBf
// module chunks = 24